<!-- START DIRECT ITEM ENTRY -->
<!--<div style="display: flex; flex-direction: column">
  <div style="display: flex; flex-direction: row">
    <div class="test quickSearchBox">AAA</div>
    <div class="test finishBox">
      <span *ngIf="!defaultFinish" class="small-text hover-underline" (click)="setDefaultFinish()">
        Set default
      </span>
      <span *ngIf="defaultFinish" class="small-text hover-underline" (click)="setDefaultFinish()">
        Default:
        {{defaultValue}}
        <span title="To remove default hit 'X'" *ngIf="isDefaultFinishAvailable" (click)="reSetDefaultFinish()"
              class="k-icon k-i-x text-danger">
        </span>
      </span>
    </div>
    <div class="test"></div>
  </div>
  <div style="display: flex; flex-direction: row">
    <div class="test">
      <div>Item ID or Description<span class="requiredField">*</span></div>
      <div>
        <kendo-autocomplete [suggest]="true"
                            [filterable]="true"
                            (filterChange)="handleItemFilter($event)"
                            (valueChange)="itemSelected($event)"
                            [(ngModel)]="selectedItemNumber"
                            name="selectedItemSuggestion"
                            [valueField]="'fullDescription'"
                            [loading]="itemsLoading"
                            [data]="filteredSuggestions"
                            [virtual]="{ itemHeight: 40 }"
                            [placeholder]="'e.g. 027660'"
                            highlightFirst="true"
                            class="w-100" #searchItem>
        </kendo-autocomplete>
      </div>
    </div>
    <div class="test">
      <div class="defaultqHeight" style="align-items:flex-end">
        <span *ngIf="defaultFinish" class="small-text hover-underline" (click)="setDefaultFinish()">
          Default:
          {{defaultValue}}
          <span title="To remove default hit 'X'" *ngIf="isDefaultFinishAvailable" (click)="reSetDefaultFinish()"
                class="k-icon k-i-x text-danger">
          </span>
        </span>
      </div>
      <div>
        Finish<span class="requiredField">*</span>
      </div>
      <div>
        <kendo-dropdownlist [data]="availableFinishes"
                            name="selectedFinishValue"
                            [(ngModel)]="selectedFinishValue"
                            textField="name"
                            valueField="value"
                            (valueChange)="finishSelected($event)"
                            [valuePrimitive]="true"
                            [loading]="loadingQuickAddFinsh" #finish>
        </kendo-dropdownlist>
      </div>
    </div>
    <div class="test">
      <span>Paint</span><span class="requiredField">*</span>
      <kendo-dropdownlist [data]="availablePaints"
                          textField="name"
                          valueField="value"
                          name="selectedPaint"
                          [(ngModel)]="selectedPaint"
                          (valueChange)="paintSelected($event)"
                          [valuePrimitive]="true"
                          [filterable]="true"
                          (filterChange)="handlePaintFilter($event)"
                          style="width:100%" [ngClass]="{'borderRed':isEmptyPaint}">

      </kendo-dropdownlist>
    </div>
    <div class="test">
      <div>Size<span class="requiredField">*</span></div>
      <kendo-dropdownlist [data]="availableSizes"
                          [(ngModel)]="selectedSize"
                          name="selectedSize"
                          textField="value"
                          valueField="value"
                          (valueChange)="sizeSelected($event)"
                          [valuePrimitive]="true" class="sizeDropStyle">
      </kendo-dropdownlist>
    </div>
    <div class="test">
      <div>
        Quantity
        <span class="requiredField">*</span>
      </div>
      <kendo-numerictextbox name="selectedQuantity"
                            [(ngModel)]="selectedQuantity"
                            [decimals]="0"
                            [autoCorrect]="true" class="width80px" [format]="'n'"
                            [min]="1" [max]="990">
      </kendo-numerictextbox>
    </div>
    <div class="test">
      <div>
        UoM
        <span class="requiredField">*</span>
      </div>
      <input class="k-textbox UoMField d-super-center"
             value="{{unitOfMeasure}}" disabled />
    </div>
    <div class="test">
      <button type="submit" (click)="onQuickAddSubmit()"
              class="k-button css-grid-item grid-item-clear-form clear-button btnGreenBorderCls">
        {{quickAddSubmitBtnText}}
      </button>
    </div>
    <div class="test">
      <button (click)="onQuickAddReset()" class="k-button css-grid-item grid-item-clear-form clear-button">
        Clear Selection
      </button>
    </div>
    <div class="test">
      <button class="k-button css-grid-item grid-item-clear-form clear-button">
        Build & Buy
      </button>
    </div>
  </div>
</div>-->
<div class="row quickMainDiv">
  <form class="quickAddFormCls">
    <!--<div class="row"  style="line-height:0;height: 0.5em;">
      <div class="col-sm-12 col-lg-5 col-md-5" style="text-align:right">
       
          <span *ngIf="!defaultFinish && selectedFinishValue" class="small-text2 hover-underline" (click)="setDefaultFinish()">
            Set default
          </span>
          <span *ngIf="defaultFinish" class="small-text2 hover-underline" (click)="setDefaultFinish()">
            Default:
            {{defaultValue}}-->
            <!--<span title="This finish is available for this item." *ngIf="isDefaultFinishAvailable"
          class="k-icon k-i-checkmark text-success">
      his finish is NOT available for this item
    </span>-->
            <!--<span title="To remove default hit 'X'" *ngIf="defaultFinish" (click)="reSetDefaultFinish()"
                  class="k-icon k-i-x text-danger" style="height:0em;line-height:0;padding-bottom:5px;">
            </span>
          </span>
    
        </div>
      </div>-->
    <div class="row">
      <div [ngClass]="{ 'col-xs-12 col-sm-12 col-lg-2 itemTopCls': showPaint,'col-xs-12 col-sm-12 col-lg-3 itemTopCls':!showPaint}">
        <div><span>{{quickAddLblTxt.idDescriptionLbl?quickAddLblTxt.idDescriptionLbl:quickAdd.idDescriptionLbl}}</span><span class="requiredField">*</span></div>
        <kendo-autocomplete [suggest]="true"
                            [filterable]="true"
                            (filterChange)="handleItemFilter($event)"
                            (valueChange)="itemSelected($event)"
                            [(ngModel)]="selectedItemNumber"
                            name="selectedItemSuggestion"
                            [valueField]="'fullDescription'"
                            [loading]="itemsLoading"
                            [data]="filteredSuggestions"
                            [virtual]="{ itemHeight: 40 }"
                            [placeholder]="'e.g. 027660'"
                            highlightFirst="true"
                            class="w-100" #searchItem>
        </kendo-autocomplete>

        <!--[ngClass]="{ 'borderRed': isInvalidItemSuggestion}"-->
      </div>

      <div class="col-sm-12 col-xs-12 col-lg-2 finishTopCls" *ngIf="availableFinishes.length>0">
        <div class="d-flex justify-content-between">
          <span>{{quickAddLblTxt.finishLbl?quickAddLblTxt.finishLbl:quickAdd.finishLbl}}<span class="requiredField">*</span></span>
          <span *ngIf="!defaultFinish && selectedFinishValue" class="small-text hover-underline" (click)="setDefaultFinish()">
            {{quickAddLblTxt.setDefaultLbl?quickAddLblTxt.setDefaultLbl:quickAdd.setDefaultLbl}}
            <span class="k-icon k-i-question" kendoTooltip style="padding-bottom: 5px;" *ngIf="!defaultFinish" title="{{defaultMessage}}"></span>
          </span>

          <span *ngIf="defaultFinish" class="small-text hover-underline" (click)="setDefaultFinish()">
            {{quickAddLblTxt.defaultLbl?quickAddLblTxt.defaultLbl:quickAdd.defaultLbl}}
            {{defaultValue}}
            <!--<span title="This finish is available for this item." *ngIf="isDefaultFinishAvailable"
              class="k-icon k-i-checkmark text-success">
          his finish is NOT available for this item
        </span>-->
            <span title="To remove default hit 'X'" *ngIf="defaultFinish" (click)="reSetDefaultFinish()"
                  class="k-icon k-i-x text-danger">
            </span>
          </span>
          <span class="k-icon k-i-question" kendoTooltip style="padding-bottom: 5px;" *ngIf="defaultFinish" title="{{closeDefaultMessage}}"></span>
        </div>
        <kendo-dropdownlist [data]="availableFinishes"
                            name="selectedFinishValue"
                            [(ngModel)]="selectedFinishValue"
                            textField="name"
                            valueField="value"
                            (valueChange)="finishSelected($event)"
                            [valuePrimitive]="true"
                            [loading]="loadingQuickAddFinsh" (blur)="validateFinish()"
                            [ngClass]="{'borderRed':isEmptyFinish}" class="responsive-class" #finish>
        </kendo-dropdownlist>
      </div>
      <div *ngIf="showPaint" class="col-sm-12 col-xs-12 col-lg-2">
        <span>{{quickAddLblTxt.paintLbl?quickAddLblTxt.paintLbl:quickAdd.paintLbl}}</span><span class="requiredField">*</span>
        <kendo-dropdownlist [data]="availablePaints"
                            textField="name"
                            valueField="value"
                            name="selectedPaint"
                            [(ngModel)]="selectedPaint"
                            (valueChange)="paintSelected($event)"
                            [valuePrimitive]="true"
                            [popupSettings]="{popupClass:'freight-popup'}"
                            [filterable]="true"
                            (filterChange)="handlePaintFilter($event)"
                            style="width:100%" (blur)="validatePaint()" [ngClass]="{'borderRed':isEmptyPaint}">

        </kendo-dropdownlist>
      </div>
      <div class="col-sm-12 col-xs-12 col-lg-1" *ngIf="availableSizes.length>0 && selectedItemSuggestion?.itemType === 1">
        <span>{{quickAddLblTxt.sizeLbl?quickAddLblTxt.sizeLbl:quickAdd.sizeLbl}}</span><span class="requiredField">*</span>
        <kendo-dropdownlist [data]="availableSizes"
                            [(ngModel)]="selectedSize"
                            name="selectedSize"
                            textField="value"
                            valueField="value"
                            (valueChange)="sizeSelected($event)"
                            [valuePrimitive]="true" class="responsive-class sizeDropStyle">
        </kendo-dropdownlist>
      </div>
      <div class="col-sm-12 col-xs-12 col-lg-2" *ngIf="selectedItemSuggestion?.itemType === 1">
        <span>
          {{quickAddLblTxt.quantityLbl?quickAddLblTxt.quantityLbl:quickAdd.quantityLbl}}
        </span><span class="requiredField">*</span>
        <kendo-numerictextbox name="selectedQuantity"
                              [(ngModel)]="selectedQuantity"
                              [decimals]="0"
                              [autoCorrect]="true" [format]="'n'"
                              [min]="1" class="qtyTxtCls responsive-class">
        </kendo-numerictextbox>
      </div>
      <div class="col-sm-12 col-xs-12 col-lg-1" *ngIf="selectedItemSuggestion?.itemType === 1">
        <span>
          {{quickAddLblTxt.uomLbl?quickAddLblTxt.uomLbl:quickAdd.uomLbl}}
        </span><span class="requiredField">*</span>
        <input class="k-textbox UoMField d-super-center"
               value="{{unitOfMeasure}}" disabled />
      </div>
      <div [ngClass]="{'col-sm-12 col-xs-12 col-lg-2 zeroRightPadding':showPaint, 'col-sm-12 col-xs-12 col-lg-3 zeroRightPadding': !showPaint, 'col-sm-12 col-xs-12 col-lg-4 zeroRightPadding':availableFinishes.length<1}"  *ngIf="selectedItemSuggestion?.itemType === 1">
        <button type="submit" (click)="onQuickAddSubmit()"
                class="k-button css-grid-item grid-item-clear-form clear-button btnGreenBorderCls" [disabled]="requestInProcess">
          {{quickAddSubmitBtnText}}<kendo-loader *ngIf="requestInProcess"
                                                 style="color:blue"></kendo-loader>
        </button>
        <button (click)="onQuickAddReset()" class="k-button css-grid-item grid-item-clear-form clear-button">
          {{quickAddLblTxt.clearSelectionLbl?quickAddLblTxt.clearSelectionLbl:quickAdd.clearSelectionLbl}}
        </button>
      </div>
      <div [ngClass]="{ 'col-sm-12 col-xs-12 col-lg-2 zeroRightPadding': showPaint,'col-sm-12 col-xs-12 col-lg-3 zeroRightPadding':!showPaint}" *ngIf="selectedItemSuggestion?.itemType === 2">
        <button class="k-button css-grid-item grid-item-clear-form clear-button" (click)="configureItem(selectedItemSuggestion)">
          {{quickAddLblTxt.buildBuyLbl?quickAddLblTxt.buildBuyLbl:quickAdd.buildBuyLbl}}
        </button>
        <button (click)="onQuickAddReset()" class="k-button css-grid-item grid-item-clear-form clear-button">
          {{quickAddLblTxt.clearSelectionLbl?quickAddLblTxt.clearSelectionLbl:quickAdd.clearSelectionLbl}}
        </button>
      </div>

    </div>
</form>

</div>
<!-- END DIRECT ITEM ENTRY -->
